/**
 * 国优炬康 管理后台主题色工具
 *
 * 品牌设置的主题色在运行时写入 CSS 变量,覆盖 styles/main.scss 的默认值。
 * Element Plus 的 hover/active 态需要 light/dark 变体,按 hex 混白/混黑生成。
 */

export const DEFAULT_THEME_COLOR = '#3DA770';

const normalize = (hex: string): string => {
  const v = (hex || '').trim();
  return /^#[0-9a-fA-F]{6}$/.test(v) ? v.toUpperCase() : DEFAULT_THEME_COLOR;
};

/** 两色按比例混合(ratio 为 hex1 权重,0-1) */
const mix = (hex1: string, hex2: string, ratio: number): string => {
  const p = (h: string) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  const [r1, g1, b1] = p(hex1);
  const [r2, g2, b2] = p(hex2);
  const c = (a: number, b: number) => Math.round(a * ratio + b * (1 - ratio));
  const to2 = (n: number) => n.toString(16).padStart(2, '0');
  return `#${to2(c(r1, r2))}${to2(c(g1, g2))}${to2(c(b1, b2))}`.toUpperCase();
};

/** 把品牌主题色应用到全局 CSS 变量(Element Plus + 自有 --gyjk-* 变量) */
export function applyThemeColor(hex: string): void {
  const color = normalize(hex);
  const root = document.documentElement.style;
  root.setProperty('--gyjk-primary', color);
  root.setProperty('--gyjk-primary-light', mix(color, '#ffffff', 0.6));
  root.setProperty('--gyjk-primary-soft', mix(color, '#ffffff', 0.12));
  root.setProperty('--gyjk-brand-dark', mix(color, '#000000', 0.35));
  root.setProperty('--el-color-primary', color);
  root.setProperty('--el-color-primary-light-3', mix(color, '#ffffff', 0.7));
  root.setProperty('--el-color-primary-light-5', mix(color, '#ffffff', 0.5));
  root.setProperty('--el-color-primary-light-7', mix(color, '#ffffff', 0.3));
  root.setProperty('--el-color-primary-light-8', mix(color, '#ffffff', 0.2));
  root.setProperty('--el-color-primary-light-9', mix(color, '#ffffff', 0.1));
  root.setProperty('--el-color-primary-dark-2', mix(color, '#000000', 0.8));
}
